import { UserPlus, PencilLine } from "lucide-react";

// Initials from first + last name (falls back to first two letters / email local-part).
function computeInitials(name) {
  const clean = name.includes("@") ? name.split("@")[0] : name;
  const parts = clean.replace(/[._-]+/g, " ").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Compact initials chip with a hover tooltip showing the person's full name.
export function UserInitialsChip({ name, testId }) {
  const full = (name || "").trim();
  if (!full) return <span data-testid={testId} className="text-xs text-zinc-600">—</span>;
  return (
    <span
      data-testid={testId}
      title={full}
      aria-label={full}
      className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-indigo-500/15 border border-indigo-500/30 text-[10px] font-semibold text-indigo-200 uppercase select-none cursor-default"
    >
      {computeInitials(full)}
    </span>
  );
}

// Icon-only list-header node with the readable label as a hover tooltip.
export function attrHeaderNode(kind) {
  const Icon = kind === "created" ? UserPlus : PencilLine;
  const label = kind === "created" ? "Created by" : "Last edited by";
  return (
    <span title={label} aria-label={label} role="img" className="inline-flex items-center text-zinc-500">
      <Icon className="h-3.5 w-3.5" />
      <span className="sr-only">{label}</span>
    </span>
  );
}

// Compact card footer: Added-by + Last-edited-by chips (left) and Updated date (right).
// Reuses the same chip design as the list views.
export function AttributionFooter({ createdName, editedName, updatedAt, testIdPrefix }) {
  return (
    <div className="mt-2 pt-2 border-t border-zinc-800 flex items-center justify-between gap-2" data-testid={testIdPrefix ? `${testIdPrefix}-attribution` : undefined}>
      <div className="flex items-center gap-3">
        <span className="flex items-center gap-1" title="Added by">
          <UserPlus className="h-3 w-3 text-zinc-500 flex-shrink-0" />
          <UserInitialsChip name={createdName} testId={testIdPrefix ? `${testIdPrefix}-creator` : undefined} />
        </span>
        <span className="flex items-center gap-1" title="Last edited by">
          <PencilLine className="h-3 w-3 text-zinc-500 flex-shrink-0" />
          <UserInitialsChip name={editedName} testId={testIdPrefix ? `${testIdPrefix}-editor` : undefined} />
        </span>
      </div>
      {updatedAt && (
        <span className="text-[11px] text-zinc-500 flex-shrink-0">Updated {new Date(updatedAt).toLocaleDateString()}</span>
      )}
    </div>
  );
}
